import { Factory } from 'miragejs';

export default Factory.extend({
  ibans: () => [],
  condition: () => {},
  target: () => {},
  createdAt: () => new Date('2020-07-24T12:34:56Z'),
});
